import $ from 'jquery';

export default function User(vm) {
    this.all = function(params) {
        var url = '/user/list?' + $.param(params);

        return vm.get(url);
    };

    this.create = function(params) {
        var url = '/user/create';

        return vm.post(url, params);
    };

    this.get = function(id) {
        var url = '/user/detail/' + id;

        return vm.get(url);
    };

    this.delete = function(params) {
        var url = null;

        if (params.is_permanent == 1)
            url = '/user/force-delete/' + params.id;
        else
            url = '/user/delete/' + params.id;

        return vm.delete(url);
    };

    this.restore = function(id) {
        var url = '/user/restore/' + id;

        return vm.get(url);
    };

    this.verifyEmail = function(params) {
        var url = '/user/verify-email';

        return vm.post(url, params);
    };
}